import jsonp from 'jsonp'
import { IsWechat } from '@/assets/scripts/wechat/index'

const BD_AK = '6m2F7440LD28DpMBzQpBQFVs'

export default function () {
  let GEO_SETTING
  //let LOCATION = {}
  let POSITION_CACHE = {}
  GEO_SETTING = {
    enableHighAcuracy: true,
    // 指定获取地理位置的超时时间，默认不限时，单位为毫秒
    timeout: 2000,
    maximunAge: 5000
  }
  return new Promise((resolve, reject) => {
    if (IsWechat()) {
      window.wx.ready(function () {
        window.wx.getLocation({
          type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
          success: function (res) {
            var latitude = res.latitude // 纬度，浮点数，范围为90 ~ -90
            var longitude = res.longitude // 经度，浮点数，范围为180 ~ -180。
            // var speed = res.speed // 速度，以米/每秒计
            // var accuracy = res.accuracy // 位置精度
            jsonp(window.location.protocol + '//api.map.baidu.com/geocoder/v2/?ak=' + BD_AK + '&output=json&callback=angular.callbacks._0&location=' + latitude + ',' + longitude, null, (err, resp) => {
              if (err) {
                reject(new Error('HTTP_ERROR'))
              } else {
                if (resp && resp.result && resp.result.addressComponent) {
                  POSITION_CACHE = resp.result.addressComponent
                  resolve(resp.result.addressComponent, resp.result.location)
                } else if (POSITION_CACHE.hasOwnProperty('city')) {
                  resolve(POSITION_CACHE)
                }
              }
            })
          }
        })
      })
    } else {
      if (window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition(function (position) {
          jsonp(window.location.protocol + '//api.map.baidu.com/geocoder/v2/?ak=' + BD_AK + '&output=json&callback=angular.callbacks._0&location=' + position.coords.latitude + ',' + position.coords.longitude, null, (err, resp) => {
            if (err) {
              reject(new Error('HTTP_ERROR'))
            } else {
              if (resp && resp.result && resp.result.addressComponent) {
                POSITION_CACHE = resp.result.addressComponent
                resolve(resp.result.addressComponent)
              } else if (POSITION_CACHE.hasOwnProperty('city')) {
                resolve(POSITION_CACHE)
              }
            }
          })
          getPositionByLocation().success(function (resp) {
            if (resp && resp.result && resp.result.addressComponent) {
              POSITION_CACHE = resp.result.addressComponent
              resolve(resp.result.addressComponent)
            } else if (POSITION_CACHE.hasOwnProperty('city')) {
              resolve(POSITION_CACHE)
            }
          }).error(function (error) {
            if (error) {}
            reject(new Error('HTTP_ERROR'))
          })
        }, function (error) {
          let code
          switch (error.code) {
            case error.TIMEOUT:
              code = 'TIMEOUT'
              break
            case error.PERMISSION_DENIED:
              window.alert('定位失败,请允许当前应用访问您的地理位置!')
              code = 'PERMISSION_DENIED'
              break
            default:
              code = 'UNKNOWN_ERROR'
              break
          }
          if (POSITION_CACHE.hasOwnProperty('city')) { resolve(POSITION_CACHE) } else { reject(new Error(code)) }
        }, GEO_SETTING)
      } else {
        reject(new Error('UNKNOWN_ERROR'))
        window.alert('您的设备暂不支持GPS定位!')
      }
    }
  })
}
